/**
 * CopyFi's colours for Clerk's screens: the sign-in form (App.tsx) and the
 * account window opened by "Change password" in the Profile. One list, so the
 * two cannot drift. (2026-09-27: the account window opened in Clerk's default
 * light theme because only the sign-in form was given these.)
 */
export const CLERK_VARIABLES = {
  colorPrimary: "#3b82f6",
  colorBackground: "#1a1d24",
  colorInputBackground: "#14161b",
  colorInputText: "#e8ecf4",
  colorText: "#e8ecf4",
  colorTextSecondary: "#8a94a6",
  colorTextOnPrimaryBackground: "#ffffff",
  colorDanger: "#ef4444",
  colorSuccess: "#22c55e",
  colorWarning: "#f59e0b",
  colorNeutral: "#e8ecf4",
  borderRadius: "0px",
  fontFamily: "'Inter', system-ui, -apple-system, sans-serif",
  fontSize: "0.875rem",
};

/**
 * Clerk's windows: the account window of "Change password" (ProfileDialog),
 * and every window Clerk opens over it by itself, given to ClerkProvider
 * (App.tsx). 2026-10-31: the "Verification required" code window opened in
 * Clerk's light theme, where index.css's white headings vanished.
 */
export const CLERK_WINDOW_VARIABLES = { ...CLERK_VARIABLES, borderRadius: "0.5rem" };
